module.exports = __webpack_public_path__ + "media/src/public/img/payment/sberbank-logo-4e1168040a4cd7078c9c6cc7c3a29d8a.svg";